import { FunctionComponent } from 'react'
import useStyles from './styles'
import { Avatar } from '@conexasaude/hero'
interface ConfirmationProfessionalReservation {
  photo: string
  professionalName: string
  professionalSpeciality: string
  description: string
}
const ConfirmationProfessionalReservation: FunctionComponent<
  ConfirmationProfessionalReservation
> = ({ photo, professionalName, professionalSpeciality }) => {
  const { confirmProfessionalSection, avatar } = useStyles()

  return (
    <div css={confirmProfessionalSection}>
      <div className="professional-avatar">
        <Avatar src={photo} styles={{ avatar: avatar }} />
        <div>
          <h5 className="text-capitalize">
            {professionalName || 'Aguardando definição'}
          </h5>
          <span>{professionalSpeciality}</span>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationProfessionalReservation
